import React from 'react';

/**
 * Diamond icon from Flaticon (ID 408472) — fashion category.
 * License: Free for personal/commercial use with attribution.
 * https://www.flaticon.com/free-icon/diamond_408472
 * Attribution: Icons made by Freepik from www.flaticon.com
 */
const DIAMOND_SRC = `${process.env.PUBLIC_URL || ''}/icons/flaticon-diamond-408472.png`;

const baseImgStyle = {
  width: '1em',
  height: '1em',
  objectFit: 'contain',
  display: 'inline-block',
  verticalAlign: '-0.125em',
};

export function DiamondOutlined(props) {
  const { className, style, ...rest } = props;
  return (
    <img
      src={DIAMOND_SRC}
      alt=""
      draggable={false}
      className={className}
      style={{
        ...baseImgStyle,
        opacity: 0.5,
        filter: 'grayscale(1) brightness(0.85)',
        ...style,
      }}
      {...rest}
    />
  );
}

export function DiamondFilled(props) {
  const { className, style, ...rest } = props;
  return (
    <img
      src={DIAMOND_SRC}
      alt=""
      draggable={false}
      className={className}
      style={{
        ...baseImgStyle,
        opacity: 1,
        filter: 'none',
        ...style,
      }}
      {...rest}
    />
  );
}
